import './index.css';
import React from 'react';
import { render } from 'react-dom';
import { App } from './App';
render(<App data-id="element-602" data-mp="1wauxqmic4h25" />, document.getElementById('root'));